import { Text } from '@chakra-ui/react'

export default function SectionHeader(props: any) {
    return (
        <Text fontSize={"1.5rem"} fontWeight={"bold"} {...props}>{props.children}</Text>
    )
}
